import React from "react";
import { turncate } from "../../../utilities/functions";

function DescCell(data) {
  return <p>{data?.description}</p>;
}

export default DescCell;
